import React from 'react';
import { VodPlayer } from '../components/ui/VodPlayer';

type PlayScreenProps = {
    screenName: string;
    screenKey: string;
};

export const PlayScreen: React.FC<PlayScreenProps> = () => {
    return (
        <>
            <VodPlayer />
        </>
    );
};
